<template>
  <div>
    <h2>Resguardo de Armamento y Municiones</h2>
    <label>
      Nombre del personal:
      <input v-model="nombre" placeholder="Nombre completo" />
    </label>
    <label>
      Fecha:
      <input v-model="fecha" type="date" />
    </label>
    <button @click="generarWord">Generar Word</button>
  </div>
</template>
<script>
import { Packer } from 'docx'
import ResguardoArmamentoMuniciones from '@/utils/doc-generator/armeria/ResguardoArmamentoMuniciones'

export default {
  data() {
    return {
      nombre: '',
      fecha: '',
    }
  },

  methods: {
    async generarWord() {
      const newDoc = await new ResguardoArmamentoMuniciones().generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'ResguardoArmamentoMuniciones.docx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
